export default function EmptyState () {
  return (
    <div>
      <p className='mb-6 text-gray-500 body'>Last month's costs</p>
      <div className='flex gap-2 items-start overflow-hidden rounded-2xl border border-color-stroke-light bg-gray-100 shadow-[0_1px_12px_0_rgba(0,0,0,0.1)]'>
        <div className='shrink-0 w-[162px] flex flex-col items-end pt-6'>
          <img src={RAILS_ASSET_URL('last-month-cost.png')} alt='Invoice' />
        </div>
        <div className='flex-1 flex items-center self-stretch px-4'>
          <p className='text-main body-sm'>
            Last month's costs will appear after the 13th of each month.
          </p>
        </div>
      </div>
    </div>
  )
}
